import {useAuth} from 'context/auth-context';
import Logo from 'components/ui/Logo/Logo';
import BusinessPartner from 'components/ui/BusinessPartner/BusinessPartner';
import UserMenu from 'components/layout/UserMenu/UserMenu';
import AutoComplete from 'components/ui/Form/AutoComplete/AutoComplete';
import Form from 'components/ui/Form/Form/Form';
import {useForm} from 'react-hook-form';
import {useLanguage} from 'context/language-context';
import styles from './PublicHeader.module.scss';

interface IProps {
    hideMenus?: boolean;
}

const PublicHeader = ({hideMenus}: IProps) => {
    const {user} = useAuth();
    const {selectedLanguage, updateLanguage, availableLanguages} =
        useLanguage();

    const formMethods = useForm({
        defaultValues: {
            language: selectedLanguage,
        },
    });

    return (
        <div className={styles.nav}>
            <Logo />
            {user && !hideMenus ? (
                <div className={styles.navMenu}>
                    <BusinessPartner
                        onOnboarding
                        className={styles.bpSelect}
                        white
                    />
                    <UserMenu white />
                </div>
            ) : (
                <div className={styles.navMenu}>
                    <Form
                        formMethods={formMethods}
                        onSubmit={() => null}
                        className={styles.form}
                    >
                        <AutoComplete
                            options={availableLanguages.map(l => ({
                                label: l.name,
                                value: l.code,
                            }))}
                            name="language"
                            onChange={changeValue => {
                                updateLanguage(
                                    (changeValue as {value: any}).value,
                                );
                            }}
                            valueKey="value"
                        />
                    </Form>
                </div>
            )}
        </div>
    );
};

export default PublicHeader;
